import { STRATEGY } from "./strategy.js";
const RULES = STRATEGY.pool.issuerStocks;
export const trustedIssuer = (id) => {
    const issuer = RULES.issuers.find((entry) => entry.id === id);
    if (issuer === undefined)
        throw new RangeError(`Unknown issuer ${id}`);
    return issuer;
};
/**
 * The trusted issuer whose mint authority this is. A match proves nothing on its own (the key can
 * be copied onto a fake mint): the caller still checks the issuer's own list before admitting.
 */
export const trustedIssuerByAuthority = (authority) => authority === null ? null : (RULES.issuers.find((e) => e.mintAuthority === authority) ?? null);
/**
 * Issuers looked at and judged not trusted (docs/issuers.md), whose controlled tokens are known:
 * no "unknown issuer" notice for them. Deliberately outside STRATEGY: it changes notices only,
 * never admission, so the rules hash and version stay put.
 */
export const VETTED_UNTRUSTED_ISSUERS = [
    {
        name: "Backpack",
        program: "FewRXXTzV2WwigvTQNsVanhEmCM9wzfNvoT1divNtbVH",
        reason: "docs/issuers.md: no regulator-named custodian, sell-back to USD only",
    },
];
/** The vetted-untrusted issuer an unknown-issuer key (`program:<owner>`) belongs to, or null. */
export const vettedIssuerByKey = (key) => VETTED_UNTRUSTED_ISSUERS.find((entry) => key === `program:${entry.program}`) ?? null;
/** The "one stock" identity of an underlying ticker: the same stock from two pools or issuers. */
export const stockKey = (underlying) => underlying.trim().toUpperCase();
/** Ondo's Jupiter symbol is the underlying ticker plus "on" (NVDAon → NVDA). */
export const ondoUnderlying = (symbol) => symbol.endsWith("on") ? symbol.slice(0, -2) : symbol;
const escaped = (term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
/** A term as a whole word, never inside a word or number: "2x" does not match "12x" or "1.2x". */
const NAME_TERMS = RULES.excludedNameTerms.map((term) => ({
    term,
    pattern: new RegExp(`(^|[^a-z0-9.])${escaped(term)}([^a-z0-9]|$)`),
}));
const PRE_IPO_TERMS = new Set(["pre-ipo", "preipo"]);
const EXCLUDED_UNDERLYINGS = new Set(RULES.excludedUnderlyings.map(stockKey));
/**
 * Why a trusted issuer's stock is not admitted (a leveraged, inverse or pre-IPO fund), or null.
 * The name is matched lower-cased with the exception phrases removed first, so a bond fund's
 * "Ultra-Short Income" is not read as a short fund.
 */
export function stockExclusion(name, underlying) {
    let lowered = name.toLowerCase();
    for (const phrase of RULES.nameTermExceptions)
        lowered = lowered.split(phrase).join(" ");
    const matched = NAME_TERMS.find(({ pattern }) => pattern.test(lowered));
    if (matched !== undefined)
        return PRE_IPO_TERMS.has(matched.term) ? "pre-IPO" : "leveraged or inverse fund";
    return EXCLUDED_UNDERLYINGS.has(stockKey(underlying)) ? "leveraged or inverse fund" : null;
}
